import { render, staticRenderFns } from "./AppMainLayout.vue?vue&type=template&id=bc4fe5c2&"
import script from "./AppMainLayout.vue?vue&type=script&lang=js&"
export * from "./AppMainLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports